export enum ReportsType {
  ProfitAndLoss = 'profitAndLoss',
  TrialBalance = 'trialBalance',
  BalanceSheet = 'balanceSheet',
}
